import { Injectable } from '@angular/core';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AbstractReportJobService } from '@/core/services/report-job/abstract-report-job.service';
import { JobStatus, ReportJob } from '@/core/services/report-job/report-job.model';

/** Alias de compatibilidade (mesma convenção do certificado de regularidade PJ). */
export type CertidaoDiretorClinicoPjJob = ReportJob;
export type CertidaoDiretorClinicoPjJobStatus = JobStatus;

/** Job service (polling/sessionStorage/download) da Certidão de Diretor Clínico PJ. */
@Injectable({ providedIn: 'root' })
export class CertidaoDiretorClinicoPjJobService extends AbstractReportJobService {
    protected readonly sessionKey = 'certidao-diretor-clinico-pj-jobId';
    protected readonly baseUrl = SICOM_PATHS.registro.prestador.reports.certidaoDiretorClinicoPj;
}
